import { createPlugin } from '@customerio/dryad';
import { ATTRIBUTE_CONDITION_TYPE } from '../../codecs/attribute-condition';
import {
  isSupportedAttributeFilter,
  parseAttributeFilter,
  serializeAttributeFilter,
  validateAttributeFilter,
  type AttributeFilterState,
  type GroupableFamily,
} from '../../codecs/attribute-filter';

/**
 * Equality + existence only, and not as UI taste: people-search executes on
 * the bitmap index path, where the backend serves only equals/exists (plus
 * email_valid and one_of) directly — anything else parses and then fails the
 * query with a 400 telling the user to wrap the condition in a segment. The
 * Ember editor clamps its operator dropdown to the same vocabulary.
 */
export const PEOPLE_SEARCH_OPERATOR_FAMILIES = ['equality', 'existence'] as const satisfies readonly GroupableFamily[];

function createDefaultState(): AttributeFilterState {
  return { field: '', operator: 'eq', value: null, value2: null };
}

/**
 * The `{ attribute: {...} }` leaf. Gated on this surface's declared families —
 * a plugin must not claim an operator its row's dropdown can't offer. A saved
 * filter carrying an unservable operator stays on the error-node passthrough
 * (dryad's fallback for unclaimed nodes, re-serialized byte-for-byte), which
 * renders as a remove-only row; since the backend rejects the filter at query
 * time either way, remove-and-rebuild is the only edit that helps.
 */
export const peopleFilterAttributePlugin = createPlugin({
  type: ATTRIBUTE_CONDITION_TYPE,
  label: 'Attribute',
  parse: (json: unknown) =>
    isSupportedAttributeFilter(json, PEOPLE_SEARCH_OPERATOR_FAMILIES) ? parseAttributeFilter(json) : null,
  serialize: serializeAttributeFilter,
  validate: validateAttributeFilter,
  createDefault: createDefaultState,
});
